/**
 * Breadcrumb label truncation utilities.
 *
 * Two truncation levels:
 * - Display truncation (30 chars): used by BreadcrumbBar for rendering labels
 * - Segment registration truncation (50 chars): used by BreadcrumbContext on setBreadcrumbs
 */

/**
 * Truncates a label for display purposes (e.g., in the BreadcrumbBar).
 * Uses the Unicode ellipsis character '…' when truncation occurs.
 *
 * @param {string} label - The label to truncate
 * @param {number} maxLength - Maximum character length before truncation (default: 30)
 * @returns {string} The original label if within limit, or truncated with ellipsis
 */
export const truncateLabel = (label, maxLength = 30) => {
  if (!label || label.length <= maxLength) return label;
  return label.substring(0, maxLength) + '\u2026';
};

/**
 * Truncates a label at segment registration time (e.g., in BreadcrumbContext).
 * Uses the Unicode ellipsis character '…' when truncation occurs.
 *
 * @param {string} label - The label to truncate
 * @param {number} maxLength - Maximum character length before truncation (default: 50)
 * @returns {string} The original label if within limit, or truncated with ellipsis
 */
export const truncateSegmentLabel = (label, maxLength = 50) => {
  if (!label || label.length <= maxLength) return label;
  return label.substring(0, maxLength) + '\u2026';
};
